import React from "react";
import { Tabs } from "antd";
import History from "../../History";
import FileList from "../../FileList/FileList";
import PartyInfo from "../../PartyInfo";
import useDetailsTabs from "./useDetailsTabs";

const { TabPane } = Tabs;

function callback(key) {
  console.log("Setting active tab key: " + key);
}
const frameStyle = {
  height: "90vh"
};
const DetailsTabs = props => {
  const { translations, admaterial, preflightReport } = useDetailsTabs();
  if (!translations) return null;
  return (
    <Tabs defaultActiveKey="1" onChange={callback}>
      <TabPane tab="Information" key="1">
        <iframe src={preflightReport.xmllogUrl} style={frameStyle} />
      </TabPane>
      <TabPane tab="Files" key="2">
        <FileList admaterial={admaterial} files={admaterial.original} />
      </TabPane>
      <TabPane tab="History" key="3">
        <History
          printed={true}
          bodyZoom={1}
          matspecid={null}
          admaterial={admaterial.id}
          translations={translations}
        />
      </TabPane>
      <TabPane tab="PartyInfo" key="4">
        <PartyInfo
          showPartytagTextarea={true}
          showSGCode={true}
          id={admaterial.id}
          translations={translations}
          internal={true}
        />
      </TabPane>
    </Tabs>
  );
};

export default DetailsTabs;



// WEBPACK FOOTER //
// ./src/components/Details/Tabs/DetailsTabs.js